import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import routes from "./routes";
import BasicLayout from "./components/layouts";

function RouteWithSubRoutes(route) {
  return (
    <Route
      path={route.path}
      exact={!!route.exact}
      render={(props) => (
        <BasicLayout>
          <route.component {...props} routes={route.routes} />
        </BasicLayout>
      )}
    />
  );
}
function RoutersWrap(props) {
  return (
    <Router>
      <Switch>
        {routes.map((route, i) => (
          <RouteWithSubRoutes key={i} {...route} />
        ))}
      </Switch>
    </Router>
  );
}
export default RoutersWrap;



// WEBPACK FOOTER //
// ./src/App.js